import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import PendoLib, { LEARNER_API_KEY } from 'js/lib/pendo';
import { useParams } from 'js/lib/useRouter';
import user from 'js/lib/user';

import EnterpriseLearningPathPageRootContent from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseLearningPathPageRootContent';
import EnterpriseLearningPathPageDataProvider from 'bundles/enterprise-learning-path-description-page/providers/pages/EnterpriseLearningPathPageDataProvider';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterpriseOrgScopedPageTemplateWrapper from 'bundles/unified-common/providers/org-scoped/EnterpriseOrgScopedPageTemplateWrapper';

const EnterpriseLearningPathPageRoot = () => {
  const { programSlug, orgSlug } = useParams();
  const isOrgScopedHome = useIsOrgScopedHome();
  const PageTemplateWrapper = isOrgScopedHome ? EnterpriseOrgScopedPageTemplateWrapper : EnterprisePageTemplateWrapper;

  React.useEffect(() => {
    try {
      PendoLib.init(
        {
          visitor: {
            id: user.get().external_id,
            isLoggedIn: user.isAuthenticatedUser(),
            isCourserian: user.isCourserian(),
          },
          account: {
            isEnterprise: true,
            ...(isOrgScopedHome ? { slug: orgSlug ?? '' } : { programSlug: programSlug ?? '' }),
          },
        },
        LEARNER_API_KEY
      );
    } catch {
      // do nothing
    }
  }, [isOrgScopedHome, orgSlug, programSlug]);
  return (
    <div data-e2e="enterprise-learning-path-page">
      <EnterpriseLearningPathPageDataProvider>
        <PageTemplateWrapper>
          <EnterpriseLearningPathPageRootContent />
        </PageTemplateWrapper>
      </EnterpriseLearningPathPageDataProvider>
    </div>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'enterprise_learning_path_description_page',
      page: 'enterprise_learning_path_page',
    },
  }))
)(EnterpriseLearningPathPageRoot);
